winlineFadeAnimator = {};
winlineFadeAnimator.SEGMENT_ANIM_TIME = 20;

winlineFadeAnimator.initialise = function() {
    winlineFadeAnimator.startSprites = [];
    winlineFadeAnimator.joinSprites = [];
    winlineFadeAnimator.endSprites = [];

    // Hide all winlines
    for (var i = 0; i < 3; i++) {
        winlineFadeAnimator.startSprites.push(resourceManager.get("slotContainer:winlinesContainer:start:" + i));
        winlineFadeAnimator.startSprites[i].visible = false;


        winlineFadeAnimator.endSprites.push(resourceManager.get("slotContainer:winlinesContainer:end:" + i));
        winlineFadeAnimator.endSprites[i].visible = false;
    }

    for (var i = 0; i < 4; i++) {
        winlineFadeAnimator.joinSprites.push( [] );
        for (var j = 0; j < 9; j++) {
            winlineFadeAnimator.joinSprites[i].push(resourceManager.get("slotContainer:winlinesContainer:join" + i + ":winlineParts:" + j));
            winlineFadeAnimator.joinSprites[i][j].visible = false;
        }
    }
};

winlineFadeAnimator.playAnimation = function(sequence, callback, maxTime) {

    callback();
    return;

    soundManager.play("winline");
    winlineFadeAnimator.completeCallback = callback;
    winlineFadeAnimator.sequence = sequence;
    winlineFadeAnimator.maxTime = maxTime;

    if (checkForUndefined(winlineFadeAnimator.maxTime)) {
        winlineFadeAnimator.maxTime = 999999999;
    }

    if (checkForUndefined(sequence.sound, "No sound was defined for sequence", true)) return;
    winlineFadeAnimator.soundFinished = false;
    soundManager.play(sequence.sound, winlineFadeAnimator.onSoundFinished);

    // Setup winlines to fade in
    var positions = sequence.data.positions;
    winlineFadeAnimator.spritesToAnimate = [];
    winlineFadeAnimator.spritesToAnimate.push( winlineFadeAnimator.startSprites[positions[0].row] );

    for (var i = 0; i < positions.length - 1; i++) {
        var spriteID = positions[i].row * 3 + positions[i+1].row;
        winlineFadeAnimator.spritesToAnimate.push( winlineFadeAnimator.joinSprites[i][spriteID] );
    }

    if (positions.length === 5) {
        winlineFadeAnimator.spritesToAnimate.push( winlineFadeAnimator.endSprites[positions[4].row] );
    }

    for (var i = 0; i < winlineFadeAnimator.spritesToAnimate.length; i++) {
        winlineFadeAnimator.spritesToAnimate[i].visible = true;
        winlineFadeAnimator.spritesToAnimate[i].alpha = 0;
    }

    winlineFadeAnimator.fadingIn = true;
    winlineFadeAnimator.currentSegment = 0;
    winlineFadeAnimator.segmentTimeRemaining = winlineFadeAnimator.SEGMENT_ANIM_TIME;

    Reflex.addToUpdate(winlineFadeAnimator.update);

};

winlineFadeAnimator.onSoundFinished = function() {
    winlineFadeAnimator.soundFinished = true;
};

winlineFadeAnimator.skipAnimation = function() {
    soundManager.stop(winlineFadeAnimator.sequence.sound);
    winlineFadeAnimator.animationComplete();
};

winlineFadeAnimator.animationComplete = function() {

    // Reset all winlines to default state
    for (var i = 0; i < winlineFadeAnimator.spritesToAnimate.length; i++) {
        winlineFadeAnimator.spritesToAnimate[i].visible = false;
        winlineFadeAnimator.spritesToAnimate[i].alpha = 1;
    }

    winlineFadeAnimator.spritesToAnimate = [];

    Reflex.removeFromUpdate(winlineFadeAnimator.update);
    winlineFadeAnimator.completeCallback();
};

winlineFadeAnimator.update = function(delta) {
    winlineFadeAnimator.segmentTimeRemaining -= delta;
    if (winlineFadeAnimator.segmentTimeRemaining <= 0) {
        // Segment Anim Complete
        winlineFadeAnimator.spritesToAnimate[winlineFadeAnimator.currentSegment].alpha = winlineFadeAnimator.fadingIn ? 1 : 0;
        winlineFadeAnimator.currentSegment++;
        if (winlineFadeAnimator.currentSegment === winlineFadeAnimator.spritesToAnimate.length) {
            // Animated all segments. Animating in or out?
            if (winlineFadeAnimator.fadingIn) {
                // We now need to fade out
                winlineFadeAnimator.fadingIn = false;
                winlineFadeAnimator.currentSegment = 0;
                winlineFadeAnimator.segmentTimeRemaining = winlineFadeAnimator.SEGMENT_ANIM_TIME;
            }
            else {
                // Animation complete
                winlineFadeAnimator.animationComplete();
            }
        }
        else {
            // Next segment
            winlineFadeAnimator.segmentTimeRemaining = winlineFadeAnimator.SEGMENT_ANIM_TIME;
        }
    }
    else {
        // Animating segment
        var progress = (winlineFadeAnimator.segmentTimeRemaining / winlineFadeAnimator.SEGMENT_ANIM_TIME);
        if (winlineFadeAnimator.fadingIn) {
            progress = 1 - progress;
        }

        winlineFadeAnimator.spritesToAnimate[winlineFadeAnimator.currentSegment].alpha = progress;
    }
};


resourceManager.registerPlugIn("winlineFadeAnimator", winlineFadeAnimator);
